import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { withDefaults } from 'vue'
interface Props {
disabled?:boolean
}
interface Emits {
  (e:'click'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    disabled: { default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e:'click'):void
}), expose: any, slots: any, attrs: any }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "rounded-lg py-3 text-base w-full",
    disabled: __props.disabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})